import React from "react";
import { useTranslation } from "react-i18next";
import ChangePassword from "./forms/ChangePassword";
import styles from "./AccountOwner.module.scss";

const AccountOwner = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h2>{t("account.page_title")}</h2>
      </div>
      <div className={styles.card}>
        <h3>{t("account.change_password")}</h3>
        <ChangePassword />
      </div>
    </div>
  );
};

export default AccountOwner;
